import {
  inject,
  Injectable,
} from '@angular/core';
import { Template } from '../../../../../core/template';
import { FirebaseFunctions } from '../../app.config';

@Injectable({
  providedIn: 'root',
})
/**
 * Contact service
 */
export class ContactService {
  private functions = inject(FirebaseFunctions)

  async contact(to: string[], template: Template, data: unknown): Promise<void> {
    return this.functions.httpsCallable<{
      to: string[],
      template: Template,
      data: unknown
    }, void>('emailing-contact', { to, template, data });
  }
}
